import { render, staticRenderFns } from "./DeleteTemplateImage.vue?vue&type=template&id=331e1b0c&scoped=true"
import script from "./DeleteTemplateImage.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateImage.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateImage.vue?vue&type=style&index=0&id=331e1b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e1b0c",
  null
  
)

export default component.exports